const initMeasurements = () => {
  const measurementRow = [...document.querySelectorAll('details')]
    .find(row => row.querySelector('summary')?.textContent?.includes('Custom Measurements'));
  const wrap = (measurementRow && [...measurementRow.querySelectorAll('.bs-wrap')]
    .find(node => node.querySelector('.bs-i[data-p]')))
    || [...document.querySelectorAll('.bs-wrap')].find(node => node.querySelector('.bs-i[data-p]'));
  const form = document.querySelector('form[action*="/cart/add"]');
  
  /* ===== 测量字段逻辑 ===== */
  if (wrap && form && !wrap.dataset.measurementsReady) {
  /* ===== 防止黑色小人被顶上去 ===== */
const updateGuidePosition = () => {
  const guide = document.querySelector('.bs-right');
  if (!guide) return;

  const baseTop = 72;
  const gap = 10;
  const guideHeight = guide.offsetHeight || 204;
  const vv = window.visualViewport;

  if (!vv) {
    guide.style.setProperty('--bs-guide-top', `${baseTop}px`);
    return;
  }

  const minTop = vv.offsetTop + 8;
  const idealTop = vv.offsetTop + baseTop;
  const maxTop = vv.offsetTop + vv.height - guideHeight - gap;
  const finalTop = Math.max(minTop, Math.min(idealTop, maxTop));

  guide.style.setProperty('--bs-guide-top', `${finalTop}px`);
};

wrap.querySelectorAll('.bs-i').forEach(input => {
  input.addEventListener('focus', () => {
    wrap.classList.add('bs-guide-active');
    updateGuidePosition();
    setTimeout(updateGuidePosition, 300);
  });

  input.addEventListener('blur', () => {
    setTimeout(() => {
      if (!wrap.querySelector('.bs-i:focus')) {
        wrap.classList.remove('bs-guide-active');
      }
    }, 120);
  });
});

if (window.visualViewport) {
  window.visualViewport.addEventListener('resize', updateGuidePosition);
  window.visualViewport.addEventListener('scroll', updateGuidePosition);
}

  /* =====上方代码时防止黑色小人被顶上去 ===== */



  wrap.dataset.measurementsReady = 'true';
    const img = document.getElementById('bs-img'), txt = document.getElementById('bs-txt');
    const base = "https://cdn.shopify.com/s/files/1/0820/0922/7490/files/";
    
    const imgMap = {
      "Height": "height.webp",
      "Neck": "neck.webp",
      "Bust": "bust.webp",
      "Under Bust": "under_bust.webp",
      "Breast Height": "breast_height.webp",
      "Neck-to-Underbust Drop": "Neck-to-Underbust_Drop.webp",
      "Waist": "waist.webp",
      "Hips": "hips.webp",
      "Thigh": "thigh.webp",
      "Knee": "Knee.webp",
      "Calf": "Calf.webp",
      "Ankle": "Ankle.webp",
      "Inseam to Ankle": "Inseam_to_Ankle.webp",
      "Waist to Ankle": "Waist_to_Ankle.webp",
      "Shoulder": "shoulder.webp",
      "Arm Length": "Arm_Length.webp",
      "Upper Arm": "Upper_Arm.webp",
      "Elbow": "Elbow.webp",
      "Wrist": "Wrist.webp",
      "Palm": "palm.webp",
      "Torso": "torso.webp",
      "Foot Length": "foot_length.webp"
    };



  const sync = (n, v) => {
      let el = form.querySelector(`input[name="properties[${n}]"]`);
      if (!el) { el = document.createElement('input'); el.type = 'hidden'; el.name = `properties[${n}]`; form.appendChild(el); }
      el.value = v;
    };

    // Keep the measurement requirements with the ordered item. The email can
    // compare these names with the submitted values without a product-ID map.
    const measurementFields = [...wrap.querySelectorAll('.bs-i[data-p]')]
      .map(input => input.dataset.p.trim())
      .filter((name, index, names) => name && names.indexOf(name) === index);
    sync('_Measurement fields', measurementFields.join('|'));
    sync('Unit', wrap.querySelector('.bs-unit input[name="u"]:checked')?.value || 'cm');
    wrap.addEventListener('input', e => {
      if (e.target.name === 'u') sync('Unit', e.target.value);
      if (e.target.dataset.p) sync(e.target.dataset.p, e.target.value);
    });

    wrap.querySelectorAll('.bs-i').forEach(input => {
      const update = () => {
        const p = input.dataset.p;
        if (imgMap[p]) {
          img.src = `${base}${imgMap[p]}`;
          txt.innerText = p.toUpperCase() + ' GUIDE';
        }
      };
      input.addEventListener('focus', update);
      input.addEventListener('mouseenter', update);
    });
  }

  
 
};

document.addEventListener('DOMContentLoaded', initMeasurements);
window.addEventListener('load', initMeasurements);

// 尺码表
const sizeData = [
    { s: 'XXS', b: '67-81', w: '54-58', h: '80-84' },
    { s: 'XS', b: '82-86', w: '59-63', h: '85-89' },
    { s: 'S', b: '87-91', w: '64-68', h: '90-94' },
    { s: 'M', b: '92-96', w: '69-73', h: '95-99' },
    { s: 'L', b: '97-101', w: '74-78', h: '100-104' },
    { s: 'XL', b: '102-106', w: '79-83', h: '105-109' },
    { s: 'XXL', b: '107-111', w: '84-88', h: '110-114' },
    { s: '3XL', b: '112-117', w: '89-94', h: '115-120' },
    { s: '4XL', b: '118-124', w: '95-101', h: '121-127' },
    { s: '5XL', b: '125-132', w: '102-109', h: '128-135' },
    { s: '6XL', b: '133-140', w: '110-117', h: '136-143' }
];

function convertRange(range, toInch) {
    if (!toInch) return range;
    return range.split('-').map(val => (parseInt(val) * 0.3937).toFixed(1)).join('-');
}

function renderTable(unit = 'cm') {
    const tbody = document.querySelector('#sizeTable tbody');
    const isInch = unit === 'inch';
    tbody.innerHTML = sizeData.map(item => `
        <tr>
            <td><strong>${item.s}</strong></td>
            <td>${convertRange(item.b, isInch)}</td>
            <td>${convertRange(item.w, isInch)}</td>
            <td>${convertRange(item.h, isInch)}</td>
        </tr>
    `).join('');
}

function openTab(evt, tabName) {
    document.querySelectorAll('.tab-content').forEach(t => t.classList.remove('active'));
    document.querySelectorAll('.tab-link').forEach(b => b.classList.remove('active'));
    document.getElementById(tabName).classList.add('active');
    evt.currentTarget.classList.add('active');
}

document.addEventListener('DOMContentLoaded', () => {
    const modal = document.getElementById('sizeChartModal');
    
    document.getElementById('openSizeChart').onclick = () => modal.classList.add('active');
    document.querySelector('.close-modal').onclick = () => modal.classList.remove('active');
    window.onclick = (e) => { if(e.target == modal) modal.classList.remove('active'); };

    document.querySelectorAll('input[name="unit"]').forEach(radio => {
        radio.onchange = (e) => renderTable(e.target.value);
    });

    renderTable(); // 初始化渲染
});

